import get from 'lodash/get'
import {
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Typography,
  Box,
  TypoTooltip,
} from '@applift/factor'

import { CreativeInfo } from '../../../../models/Creative'
import { EMPTY_VALUE } from '../../helpers'

import styles from './styles.module.scss'

interface Props {
  creativeDetails: CreativeInfo | null
  infoMapper: any
  isOpen: boolean
  setIsOpen: (open: boolean) => void
}

export const CreativeDetailsBlock = (props: Props) => {
  const { creativeDetails, infoMapper, isOpen, setIsOpen } = props

  const dataIndexable = { ...creativeDetails }

  const getInfoItem = (infoItem: {
    value: (arg0: CreativeInfo | null) => any
  }) =>
    typeof infoItem.value === 'string'
      ? get(dataIndexable, infoItem.value, EMPTY_VALUE) || EMPTY_VALUE
      : infoItem.value(creativeDetails)

  return (
    <Accordion
      sx={{
        boxShadow: 200,
        mt: 0,
      }}
      onChange={() => setIsOpen(!isOpen)}
      expanded={isOpen}
    >
      <AccordionSummary
        aria-controls="creativeDetails-content"
        id="creativeDetails-contentField"
      >
        <Typography
          sx={{
            textWeight: 'demi',
            mr: 16,
          }}
        >
          Creative Details
        </Typography>
      </AccordionSummary>
      <AccordionDetails sx={{ p: 16, width: 100 }}>
        {!!infoMapper &&
          infoMapper.map((infoItem: any) => (
            <Box className={styles.infoItem} key={infoItem.key}>
              <Box Component="span" className={styles.infoKey}>
                {infoItem.key}:
              </Box>

              <TypoTooltip title={getInfoItem(infoItem)}>
                {getInfoItem(infoItem)}
              </TypoTooltip>
            </Box>
          ))}
      </AccordionDetails>
    </Accordion>
  )
}
